import { render, staticRenderFns } from "./DomainAuthenticateModal.vue?vue&type=template&id=1057b8d8&scoped=true"
import script from "./DomainAuthenticateModal.vue?vue&type=script&lang=js"
export * from "./DomainAuthenticateModal.vue?vue&type=script&lang=js"
import style0 from "./DomainAuthenticateModal.vue?vue&type=style&index=0&id=1057b8d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1057b8d8",
  null
  
)

export default component.exports